import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import GouldsContent from "./GouldsPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/goulds/pumps" component={GouldsContent} />
          <Route path="/suppliers/goulds">
            <Redirect to="/suppliers/goulds/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
